/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { LableFromEnums } from "../../../utilities";
import { toast } from "react-toastify";
import {
  GetCoachBookingDetails,
  GetSessionSoltsByGroup,
} from "../../../utilities/api/coachingBooking";

const CoachingBookingSummary = ({ summaryBooking }: any) => {
  const componentRef = useRef<HTMLDivElement>(null);
  const { Enums } = useAppSelector((state) => state.enumsArray);
  const [slots, setSlots] = useState<any>([]);


  const [totalTax, setTotalTax] = useState(0);
  const [ratePerSession, setRatePerSession] = useState(0);
  const [ratePerWeek, setRatePerWeek] = useState(0);

  const [offerData, setOfferData] = useState({}) as any;
  const [coachBookingData, setCoachBookingData] = useState<any>({});
  const [printing, setPrinting] = useState(false);

  const handlePrint = () => {
    setPrinting(true);
    window.open(
      "/printing/?type=summary&prefix=SB&id=" + coachBookingData.id + "&hash=" + coachBookingData?.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);

  };

  useEffect(() => {
    GetCoachBookingDetails(summaryBooking)
      .then((response) => {
        const data = response?.data || {};
        setCoachBookingData({
          ...data,
        });
        const _ratePerSession = data?.ratePerSession;
        setRatePerSession(_ratePerSession);
        setRatePerWeek(_ratePerSession * data?.noOfDays);

        setOfferData({ discountPercent: data?.offerPercent });
        let getTotalTax = 0;

        data?.bookingTaxes.forEach((_tax: any) => {
          getTotalTax += _tax?.percentage;
        });

        setTotalTax(getTotalTax);
      })
      .catch((error) => toast.error(error.message));

    GetSessionSoltsByGroup(summaryBooking)
      .then((response) => {
        let data = [] as any;
        response.data.forEach((item: any) => {
          item.list.forEach((elem: any) => {
            data.push(elem);
          });
        });

        setSlots(data);
      })
      .catch((error) => toast.error(error.message));
  }, []);


  return (
    <>
      <div className="page-title align-items-center d-flex justify-content-between">
        <Card.Title className="mb-0">Coaching Booking Summary </Card.Title>
        <Button
          type="button"
          bname={printing ? "Printing" : "Print"}
          name="print"
          id="print"
          className="btn btn-light rounded-1 me-3"
          onClick={handlePrint}
          disabled={printing}
        ></Button>
      </div>
      <div ref={componentRef} className="print-content">
        <Row>
          <Col lg={7}>
            <div className="coach-booking-details pb-5">
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Attendee Name
                  </span>
                  <span className="user-info">{`${coachBookingData?.attendee?.firstName} ${coachBookingData?.attendee?.lastName}`}</span>
                </Col>
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Contact Number
                  </span>
                  <span className="user-info">
                    {coachBookingData?.user?.phone}
                  </span>
                </Col>
              </Row>
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Facility Name
                  </span>
                  <span className="user-info">
                    {coachBookingData?.facilityName}
                  </span>
                </Col>
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Session Name
                  </span>
                  <span className="user-info">
                    {coachBookingData?.sessionName}
                  </span>
                </Col>
              </Row>
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Sports Name{" "}
                  </span>
                  <span className="user-info">
                    {coachBookingData?.sportName}
                  </span>
                </Col>
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Number of session Aligned{" "}
                  </span>
                  <span className="user-info">
                    {coachBookingData?.noOfSessionToAttend}
                  </span>
                </Col>
              </Row>
              <Row className="text-start row-mb">
                <Col>
                  <span className="user-info-title text-info text-uppercase d-block mb-2">
                    Court's Name
                  </span>
                  <span className="user-info">
                    {coachBookingData?.session?.sessionCourts?.map(
                      (item: any, index: number) =>
                        index !==
                          coachBookingData?.session?.sessionCourts?.length - 1
                          ? `${item?.court?.name}, `
                          : item?.court?.name
                    )}
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={5}>
            <div className="fs-6 fw-semibold h5 mb-2 text-start">
              Booked Period
            </div>
            <p className="fs-7 fst-italic fw-semibold ms-2 text-start mb-0">
              {coachBookingData?.startDate} to {coachBookingData?.endDate}
            </p>
            <table className="table table-bordered ">
              <thead>
                <tr>
                  <th>Days</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {slots?.map((item: any, index: number) => {
                  return (
                    <tr key={"slots" + index}>
                      <td>{item.attendanceDay}</td>

                      <td>
                        {item.startTime} to {item.endTime}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </Row>
        <Row className="text-end">
          <hr />
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Rate Per Session:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {ratePerSession?.toFixed(2) || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Selected Session Per week:{" "}
            </span>
            <span className="user-info">
              {" "}
              {coachBookingData?.noOfDays || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Weekly Session Price:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {ratePerWeek?.toFixed(2) || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Weeks Enrolled:{" "}
            </span>
            <span className="user-info">
              {" "}
              {coachBookingData?.noOfWeeks || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Offer ({offerData?.discountPercent || 0}%):{" "}
            </span>
            <span className="user-info">
              -<span className="rupees-symbol">&#8377;</span>
              {Math.ceil(
                ratePerWeek *
                coachBookingData?.noOfWeeks *
                (offerData?.discountPercent / 100)
              )}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Sub Total:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {coachBookingData?.subTotal?.toFixed(2) || 0}
            </span>
          </Col>

          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Discount:{" "}
            </span>
            <span className="user-info">
              -<span className="rupees-symbol">&#8377;</span>{" "}
              {coachBookingData?.discount?.toFixed(2) || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Total Tax({totalTax}%):{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {coachBookingData?.totalTax?.toFixed(2) || 0}
            </span>
          </Col>

          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Payable Amount:{" "}
            </span>
            <span className="user-info">
              <span className="rupees-symbol">&#8377;</span>{" "}
              {Math.round(coachBookingData?.totalAmount) || 0}
            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Payment Mode:{" "}
            </span>
            <span className="user-info">
              {LableFromEnums(
                coachBookingData?.bookingPayments?.[0]?.payment?.method,
                Enums
              )}

            </span>
          </Col>
          <Col md={{ span: 4, offset: 8 }} className="mb-3">
            <span className="user-info-title text-info text-uppercase mb-2">
              Payment Status:{" "}
            </span>
            <span className="user-info">
              {LableFromEnums(coachBookingData?.paymentStatus, Enums)}

            </span>
          </Col>
          <Col lg={12}>
            <span className="d-block fst-italic fw-semibold mt-3">
              <sup>*</sup>The Amount is inclusive of all the taxes
            </span>
          </Col>
        </Row>
      </div>
    </>
  );
};
export { CoachingBookingSummary };
